// eslint-disable-file
import styled from 'styled-components'

export const StyledHero = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
`
